<script>
	import { goto } from '$app/navigation';
	import { page } from '$app/stores';
	import '../app.css';
</script>

<div class="flex min-h-full flex-col bg-white pt-16 pb-12">
	<main
		style="height: 50vh;"
		class="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8"
	>
		<div class="flex flex-shrink-0 justify-center">
			<a
				on:click={() => {
					location.href = '/';
				}}
				href="#"
				class="inline-flex"
			/>
		</div>
		<div class="py-16">
			<div class="text-center">
				<p class="text-base font-semibold text-indigo-600">{$page.status}</p>
				<h1 class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
					{$page.error.message}
				</h1>

				<div class="mt-6">
					<a
						on:click={() => {
							location.href = '/';
						}}
						href="#"
						class="text-base font-medium text-indigo-600 hover:text-indigo-500"
					>
						На главную
						<span aria-hidden="true"> &rarr;</span>
					</a>
				</div>
			</div>
		</div>
	</main>
</div>
